/**
 * F10 — Two-domain entry behavior (LitCurrent side only).
 * LitCurrent domain → workspace dashboard. Shared auth; no account fragmentation.
 */

const LITPULSE_DOMAIN_HINTS = [
  process.env.REACT_APP_LITPULSE_DOMAIN,
  'litpulse',
  'app.litpulse',
].filter(Boolean) as string[];

/** Default post-login / catch-all landing for LitCurrent workspace. */
export const LITPULSE_DEFAULT_LANDING = '/library';

export function isLitCurrentHost(hostname: string = window.location.hostname): boolean {
  const host = hostname.toLowerCase();
  if (LITPULSE_DOMAIN_HINTS.some((hint) => host.includes(hint.toLowerCase()))) {
    return true;
  }
  // Local dev and unknown hosts default to LitCurrent workspace
  return host === 'localhost' || host === '127.0.0.1' || !host.includes('portal');
}

export function getDefaultLandingPath(): string {
  return LITPULSE_DEFAULT_LANDING;
}
